<form #f="ngForm" (ngSubmit)="f.form.valid && createOrEditGroupDocument()">
    <mat-card class="modal-add-document">
        <!-- <mat-card-header>
            <mat-card-title class="mat-card-title-custom" *ngIf="!documents.id">
                <span>{{'service_type.add_service_type' | translate}}</span>

            </mat-card-title>
        </mat-card-header> -->
        <h2 mat-dialog-title mat-dialog-draggable-title *ngIf="!documents.id"> {{'service_type.add_service_type' | translate}}
            <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
              <span aria-hidden="true">&times;</span>
            </button>
        </h2>

        <mat-divider></mat-divider>
        <mat-card-content class="mb-3 mat-card-content-contract-sm" style="overflow: auto; height: 600px;">
            <!--Thông tin loại hợp đồng-->
            <mat-accordion>
                <mat-expansion-panel expanded="true" class="mt-3">
                    <mat-panel-title class="mat-panel-title mt-3 d-flex justify-content-between align-items-center" style="position: relative;">
                        <span>{{'service_type.contract_type_info' | translate}}</span>
                        <small style="position: absolute; right:0px" class="form-text text-gray pull-right">
                            (<span style="color: red;">*</span>) {{'form.info' | translate}}
                        </small>
                    </mat-panel-title>
                    <ng-container *ngIf="documents.id && documents.type == 2;else addOrDocDefault">
                        <div class="row pt-3 pb-3">
                            <!-- Mã loại hợp đồng -->
                            <div class="col-12 d-flex">
                                <label class="col-sm-3 col-form-label">{{'search_form.service_type_code' |
                                    translate}}</label>
                                <label class="col-sm-9 col-form-label font-weight-bold">
                                    {{documents.code}}
                                </label>
                            </div>
                            <!-- Tên loại hợp đồng-->
                            <div class="col-12 d-flex">
                                <label class="col-sm-3 col-form-label">{{'search_form.service_type_name' |
                                    translate}}</label>
                                <label class="col-sm-9 col-form-label font-weight-bold">
                                    {{documents.name}}
                                </label>
                            </div>
                            <!-- Ghi chú -->
                            <div class="d-flex" [ngClass]="{'col-12': !isShareMysignEnable, 'col-6': isShareMysignEnable}">
                                <label class="col-sm-3 col-form-label">{{'search_form.note' | translate}}</label>
                                <label class="col-sm-9 col-form-label font-weight-bold">
                                    {{documents.note}}
                                </label>
                            </div>

                          <!-- Nhóm Mysign -->
                          <div class="col-6 d-flex" *ngIf="isShareMysignEnable">
                            <mat-form-field class="w-100">
                              <mat-label>{{'search_form.service_type_groupName' | translate}}</mat-label>
                              <mat-select (selectionChange)="onChange($event)" [(value)]="selectedGroup">
                                <mat-option *ngIf="!groupsDTOS || groupsDTOS.length === 0"
                                            [value]="'default'">{{'search_form.service_type_noGroupName' | translate}}</mat-option>
                                <mat-option *ngFor="let groupsDTO of groupsDTOS" [value]="groupsDTO">
                                  {{ groupsDTO.name }}
                                </mat-option>
                                <mat-option *ngIf="isLoading" disabled>
                                  <mat-spinner diameter="20"></mat-spinner>
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                        </div>
                    </ng-container>
                    <ng-template #addOrDocDefault>
                        <div class="row pt-3 pb-3">
                            <!-- Mã loại hợp đồng -->
                            <div class="col-12">
                                <mat-form-field class="w-100">
                                    <input type="text"
                                        (focusout)="documents.code = documents.code == undefined ? '' : (documents.code + '').trim();convertData()"
                                        #focusCode matInput [placeholder]="'search_form.service_type_code' | translate"
                                        name="code" [(ngModel)]="documents.code" required autocomplete="off"
                                        #code="ngModel" maxlength="255" (ngModelChange)="onChangeFormInput('code')">
                                    <button mat-button *ngIf="documents.code" type="button" matSuffix mat-icon-button
                                        aria-label="Clear" (click)="documents.code=''">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                    <mat-error *ngIf="code.invalid">
                                        {{'validation.service_type_code_require' | translate}}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <!-- Tên nhóm-->
                            <div class="col-12">
                                <mat-form-field class="w-100">
                                    <input type="text"
                                        (focusout)="documents.name = documents.name == undefined ? '' : (documents.name + '').trim()"
                                        #focusInput matInput [placeholder]="'search_form.service_type_name' | translate"
                                        name="name" [(ngModel)]="documents.name" required autocomplete="off"
                                        #name="ngModel" maxlength="255" (ngModelChange)="onChangeFormInput()">
                                    <button mat-button type="button" matSuffix mat-icon-button aria-label="Clear"
                                        *ngIf="documents.name" (click)="documents.name=''">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                    <mat-error *ngIf="name.invalid">
                                        {{'validation.service_type_name_require' | translate}}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <!-- Ghi chú -->
                            <div  class="d-flex" [ngClass]="{'col-12': !isShareMysignEnable, 'col-6': isShareMysignEnable}">
                                <mat-form-field class="w-100">
                                    <textarea (focusout)="documents.note=documents.note.trim()" type="text" matInput
                                        [placeholder]="'search_form.note' | translate" rows="2" name="note"
                                        maxlength="255" (ngModelChange)="onChangeFormInput()" id="description"
                                        [(ngModel)]="documents.note">
                                    </textarea>
                                </mat-form-field>
                            </div>
                          <!-- Nhóm Mysign -->
                          <div class="col-6 d-flex" *ngIf="isShareMysignEnable">
                            <mat-form-field class="w-100">
                              <mat-label>{{'search_form.service_type_groupName' | translate}}</mat-label>
                              <mat-select (selectionChange)="onChange($event)" [(value)]="selectedGroupId">
                                <mat-option *ngIf="!groupsDTOS || groupsDTOS.length === 0"
                                            [value]="'default'">{{'search_form.service_type_noGroupName' | translate}}</mat-option>
                                <mat-option *ngFor="let groupsDTO of groupsDTOS" [value]="groupsDTO.groupId">
                                  {{ groupsDTO.name }}
                                </mat-option>
                                <mat-option *ngIf="isLoading" disabled>
                                  <mat-spinner diameter="20"></mat-spinner>
                                </mat-option>

                              </mat-select>
                              <button
                                mat-button
                                type="button"
                                matSuffix
                                mat-icon-button
                                aria-label="Clear"
                                *ngIf="isShowClearButton()"
                                (click)="clearData()"
                              >
                                <mat-icon>close</mat-icon>
                              </button>
                            </mat-form-field>
                          </div>

                        </div>
                    </ng-template>
                </mat-expansion-panel>
            </mat-accordion>
            <mat-card-content class="mb-3 mat-card-content-contract-sm">
                <!-- Cấu hình mã số hợp đồng tự động -->
                <mat-accordion>
                    <mat-expansion-panel expanded="true" class="mt-3">
                        <mat-panel-title class="mat-panel-title mt-3 d-inline-block justify-content-between align-items-center" style="position: relative;">
                            {{'search_form.auto_number' | translate}}
                            <mat-icon class="configure__head-help-icon"
                                style="cursor: pointer;"
                                (click)="createTplModal(tplHelpAutoTitle, tplHelpAutoContent, tplHelpAutoFooter,true)">
                                help_outline
                            </mat-icon>
                            <ng-template #tplHelpAutoTitle>
                                <span>{{'service_type.config_contract_code.config_contract_code_title' |
                                    translate}}</span>
                            </ng-template>
                            <ng-template #tplHelpAutoContent>
                                <p>{{'service_type.config_contract_code.modal_content1' | translate}}</p>
                                <p class="font-italic" style="margin-bottom: 0.5em !important;">
                                    <b>{{'service_type.config_contract_code.number_range' | translate}}</b>
                                    {{'service_type.config_contract_code.modal_content2' | translate}}
                                </p>
                                <ul class="font-italic" style="margin-bottom: 0.5em !important;">
                                    <li>{{'service_type.config_contract_code.number_range_ex_1' | translate}}</li>
                                    <li>{{'service_type.config_contract_code.number_range_ex_2' | translate}}</li>
                                    <li>{{'service_type.config_contract_code.number_range_ex_3' | translate}}</li>
                                    <li>{{'service_type.config_contract_code.number_range_ex_4' | translate}}</li>
                                    <li>{{'service_type.config_contract_code.number_range_ex_5' | translate}}</li>
                                    <li>{{'service_type.config_contract_code.number_range_ex_6' | translate}}</li>
                                </ul>
                                <p class="font-italic">{{'service_type.config_contract_code.modal_content3' |
                                    translate}}</p>
                                <p class="font-italic" style="margin-bottom: 0.5em !important;">
                                    <b>{{'service_type.config_contract_code.time' | translate}}</b>
                                    {{'service_type.config_contract_code.modal_content4' | translate}}
                                </p>
                                <ul class="font-italic" style="margin-bottom: 0.5em !important;">
                                    <li>{{'service_type.config_contract_code.time_dd' | translate}}</li>
                                    <li>{{'service_type.config_contract_code.time_mm' | translate}}</li>
                                    <li>{{'service_type.config_contract_code.time_yy' | translate}}</li>
                                    <li>{{'service_type.config_contract_code.time_yyyy' | translate}}</li>
                                </ul>
                                <p class="font-italic" style="margin-bottom: 0.5em !important;">
                                    {{'service_type.config_contract_code.modal_content5' | translate}}</p>
                                <p class="font-italic">{{'service_type.config_contract_code.modal_content6' |
                                    translate}}</p>
                                <p class="font-italic"><b>{{'service_type.config_contract_code.contract_type_code' |
                                        translate}}</b>
                                    {{'service_type.config_contract_code.modal_content7' | translate}}
                                </p>
                                <p class="font-italic"><b>{{'service_type.config_contract_code.input' | translate}}</b>
                                    {{'service_type.config_contract_code.modal_content8' | translate}}
                                </p>
                                <p>{{'service_type.config_contract_code.modal_content9' | translate}}</p>
                                <p class="font-italic" style="color: red;">
                                    <b>{{'service_type.config_contract_code.modal_content10' | translate}}</b>
                                    {{'service_type.config_contract_code.modal_content11' | translate}}
                                </p>
                            </ng-template>
                            <ng-template #tplHelpAutoFooter>
                                <button nz-button (click)="destroyTplModal()"
                                    class="v2-color-deny" type="button">
                                    {{'button.close' | translate}}
                                </button>
                            </ng-template>
                        </mat-panel-title>
                        <div class="row">
                            <!-- Cấu hình đánh số tự động-->
                            <div class="col-md-12 reminder-to-sign font-weight-bold">
                                {{'search_form.expriration_auto_number' | translate}}
                                <mat-button-toggle-group class="toggle-button">
                                    <mat-button-toggle [checked]="documents.isOnAutoNumber" value="on"
                                        (click)="clickSendAutoNumber(true)">{{'search_form.btn_config_notify_on' |
                                        translate}}
                                    </mat-button-toggle>
                                    <mat-button-toggle [checked]="!documents.isOnAutoNumber" value="off"
                                        (click)="clickSendAutoNumber(false)">{{'search_form.btn_config_notify_off' |
                                        translate}}
                                    </mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                            <div class="col-md-12" style="margin-top:20px;" *ngIf="documents.isOnAutoNumber">
                                <span class="font-weight-bold"
                                    style="font-size: 15px; border-bottom: 1px solid #0000001f;padding: 20px 0px;">{{'search_form.config_contract_code_addendum'
                                    | translate}}</span>
                            </div>
                            <!--Loại cấu hình-->
                            <div class="col-md-12 reminder-to-sign mt-4" style="margin-bottom: 20px;"
                                *ngIf="documents.isOnAutoNumber">
                                <div style="width: 220px;">{{'search_form.contract_code_component' | translate}}</div>

                                <!-- Chọn thành phần -->
                                <div style="width:220px; margin-right: 40px;">
                                    <mat-form-field>
                                        <mat-label >{{'timestamp.table_header.type' | translate}}</mat-label>
                                        <mat-select
                                            (selectionChange)="onChangeSelectComponent($event,'ComponentType')"
                                            [(ngModel)]="selectedComponentType"
                                            name="selectedComponentType"
                                            id="selectedComponentType">
                                            <!-- <mat-option [value]=0 selected>{{'timestamp.table_header.type' | translate}}</mat-option> -->
                                            <mat-option
                                                *ngFor="let component of listKeyConfig"
                                                [value]="component.value">
                                                {{component.viewValue | translate}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <div *ngIf="invalidNumber" class="mat-error message-error">
                                        {{'validation.number_range_type_already_exists'| translate}}
                                    </div>
                                </div>
                                <!-- Định dạng -->
                                <div style="width:220px; margin-right: 40px;" *ngIf="!selectedComponentType">
                                    <mat-form-field>
                                        <mat-label>{{'search_form.format' | translate}}</mat-label>
                                        <mat-select disabled>
                                            <mat-option value="1"></mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <!-- Dải số -->
                                <div style="width:220px; margin-right: 40px;" *ngIf="selectedComponentType === 1">
                                    <mat-form-field>
                                        <!-- <mat-label>{{'search_form.component_number' | translate}}</mat-label> -->
                                        <mat-label>{{'search_form.format' | translate}}</mat-label>
                                        <mat-select [disabled]="invalidNumber != 0" (openedChange)="addSelect($event)"
                                            (selectionChange)="onChangeSelectComponent($event,'numberRange')"
                                            [(ngModel)]="selectedNumber" name="selectNumber" id="selectNumber">
                                            <mat-option *ngFor="let component of listNumber" [value]="component">
                                                {{ component.viewValue | translate}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <!-- time -->
                                <div style="width:220px; margin-right: 40px;" *ngIf="selectedComponentType === 2">
                                    <mat-form-field>
                                        <!-- <mat-label>{{'search_form.component_time' | translate}}</mat-label> -->
                                        <mat-label>{{'search_form.format' | translate}}</mat-label>
                                        <mat-select (openedChange)="addSelect($event)"
                                            (selectionChange)="onChangeSelectComponent($event,'time')"
                                            [(ngModel)]="selectedTime" name="selectTime" id="selectTime">
                                            <mat-option *ngFor="let component of listTime" [value]="component">
                                                {{component.viewValue | translate}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <!-- Mã loại hợp đồng -->
                                <div style="width:220px; margin-right: 40px;" *ngIf="selectedComponentType === 3">
                                    <mat-form-field>
                                        <!-- <mat-label>{{'search_form.component_text' | translate}}</mat-label> -->
                                        <input class="input-cycle" matInput disabled name="selectCode" id="selectCode"
                                            (ngModelChange)="onChangeFormInput()"
                                            [(ngModel)]="documents.code ? documents.code: constractCode"
                                            (keydown.space)="$event.preventDefault()" #timeNotify="ngModel">
                                    </mat-form-field>
                                </div>
                                <!-- text -->
                                <div style="width:220px; margin-right: 40px;" *ngIf="selectedComponentType === 4">
                                    <mat-form-field>
                                        <mat-label>{{'search_form.content' | translate}}</mat-label>
                                        <input (focusout)="selectedText=selectedText.trim()" class="input-cycle" matInput name="selectText" id="selectText"
                                            (ngModelChange)="onChangeFormInput('free_text')"
                                            (change)="onChangeFormInput('free_text')" [(ngModel)]="selectedText"
                                            #timeNotify="ngModel">
                                    </mat-form-field>
                                    <div *ngIf="invalidText && isSubmit" class="mat-error message-error">
                                        {{'validation.content_must_not_spaces' | translate}}
                                    </div>
                                </div>

                                <div style="width:220px;padding-bottom: 1.2em;">
                                    <button style="width: 90px!important;min-width: unset!important;"
                                        [disabled]="!selectedComponentType || (selectedComponentType !== 3 && !selectedNumber.value && !selectedTime.value && !selectedText)"
                                        mat-stroked-button type="button" color="primary" class="button"
                                        (click)="saveComponentType()">
                                        <mat-icon class="mr-0">add_circle</mat-icon>
                                        {{'search_form.add_component' | translate}}
                                    </button>
                                </div>
                            </div>

                            <div class="col-md-12" *ngIf="isFormChanging || isUpdate">
                                <p *ngIf="documents.isOnAutoNumber && listDataPreview.length > 0"
                                    style="font-size: 14px;">
                                    {{'search_form.selected_contract_code_format' |
                                    translate}} (<span style="font-style: italic;">{{'search_form.drag_and_change' |
                                        translate}}</span>)</p>

                                <div class="angular-container" cdkDropListGroup *ngIf="documents.isOnAutoNumber">
                                    <div cdkDropList [cdkDropListEnterPredicate]="dropListEnterPredicate"
                                        (cdkDropListDropped)="dropListDropped()"></div>
                                    <div cdkDropList *ngFor="let item of listDataPreview"
                                        [cdkDropListEnterPredicate]="dropListEnterPredicate"
                                        (cdkDropListDropped)="dropListDropped()">
                                        <div cdkDrag class="angular-box" (cdkDragMoved)="dragMoved($event)">
                                            <p class="viewValue" [class.viewText]="item.type == 4">
                                                {{ item.type == 4 ? (item.value.toString().length
                                                >
                                                30 ? item.value.slice(0,30) : item.value) : item.viewValue }}
                                                <span class="viewRangeNumber"
                                                    *ngIf="(item.type != 2 && item.type != 4 && item.type != 3) || (item.type == 3 && documents.code)">({{item.value.toString().trim().length
                                                    > 30 ? item.value.slice(0,30) : item.value.toString().trim()}})</span>
                                                <span class="viewTime"
                                                    *ngIf="item.type == 2">({{item.displayValue}})</span>
                                                <span class="deleteComponent" (click)="deleteComponent(item)">
                                                    x
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-12 reminder-to-sign font-italic" style="font-weight: normal;"
                                *ngIf="documents.isOnAutoNumber && previewDataDisplay">
                                <span style="font-weight: normal;">{{'search_form.example_compnent' |
                                    translate}}&nbsp;</span>
                                <span [innerHTML]="previewDataDisplay">&nbsp;</span>
                            </div>
                            <div class="col-md-12 reminder-to-sign font-italic" *ngIf="documents.isOnAutoNumber">
                                <span>{{'history_report.note' | translate}}</span>&nbsp;
                                <span style="font-weight: normal;">{{'search_form.current_format_length' |
                                    translate}}</span>
                                <span class="preview-data" style="color: red;">{{vldMaxlength.length}}/50&nbsp;</span>
                                <span class="preview-data"> {{'search_form.max_contract_code_length' |
                                    translate}}</span>
                            </div>
                            <div class="col-md-12 reminder-to-sign font-italic" style="color: red;"
                                *ngIf="documents.isOnAutoNumber && vldMaxlength.length > 50">
                                {{'search_form.length_contract_maximum' | translate}}
                            </div>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>


            </mat-card-content>
            <mat-card-content class="mb-3 mat-card-content-contract-sm">
                <!-- Cấu hình loại hợp đồng -->
                <mat-accordion>
                    <mat-expansion-panel expanded="true" class="mt-3">
                        <mat-panel-title class="mat-panel-title mt-3 d-flex justify-content-between align-items-center">
                            {{'search_form.contract_type_config' | translate}}
                        </mat-panel-title>
                        <!--radio group-->
                        <div class="col-12 mb-3 d-flex">
                            <!--Checkbox cau hinh chung-->
                            <div class="group-checkbox px-3">
                                <button id="config-general" type="button" mat-icon-button class="v2-color-deny"
                                    [disabled]="documents.id && documents.type == 2 ? true : false"
                                    (click)="onAllowCheckSign('generalConfig')">
                                    <mat-icon *ngIf="documents.configGeneral === 1"
                                        [ngClass]="documents.id && documents.type == 2 ? '' : 'mat-primary'">
                                        radio_button_checked
                                    </mat-icon>
                                    <mat-icon *ngIf="documents.configGeneral !== 1"
                                        [ngClass]="documents.id && documents.type == 2 ? '' : 'mat-primary'">
                                        radio_button_unchecked
                                    </mat-icon>
                                </button>
                                <label class="checkbox-label" style="font-weight: 500;" for="config-general">
                                    {{'button.config' | translate}}
                                </label>
                            </div>
                            <!--Checkbox cau hinh rieng-->
                            <div class="group-checkbox px-3">
                                <button id="config-individual" type="button"
                                    [disabled]="documents.id && documents.type == 2 ? true : false" mat-icon-button
                                    class="v2-color-deny" (click)="onAllowCheckSign('individualConfig')">
                                    <mat-icon *ngIf="documents.configGeneral === 2"
                                        [ngClass]="documents.id && documents.type == 2 ? '' : 'mat-primary'">
                                        radio_button_checked
                                    </mat-icon>
                                    <mat-icon *ngIf="documents.configGeneral !== 2"
                                        [ngClass]="documents.id && documents.type == 2 ? '' :' mat-primary'">
                                        radio_button_unchecked
                                    </mat-icon>
                                </button>
                                <label class="checkbox-label" style="font-weight: 500;" for="config-individual">
                                    {{'button.individual_config' | translate}}
                                </label>
                            </div>
                        </div>
                        <section style="color: red; padding-left: 30px; font-style: italic"
                        *ngIf="haveConfig == 0 && documents.configGeneral == 1"
                        >
                        <span>{{'validation.config_general_not_found' | translate}}</span>
                        <a style="text-decoration: underline; color: #4e73df;"
                        (click)="navigateConfig()">{{'header.enterprise_service_types' |
                            translate}}</a>
                        <span>{{'validation.to_setting' | translate}}</span>
                    </section>
                    </mat-expansion-panel>
                </mat-accordion>
            </mat-card-content>
            <mat-card-content class="mb-3 mat-card-content-contract-sm" *ngIf="documents.configGeneral == 2">
                <!--Cấu hình ký-->
                <mat-accordion>
                    <mat-expansion-panel expanded="true" class="mt-3">
                        <mat-panel-title class="mat-panel-title mt-3 d-inline-block justify-content-between align-items-center" style="position: relative;">
                            {{'header.sign_config' | translate}}
                            <mat-icon class="configure__head-help-icon"
                                style="cursor: pointer;"
                                (click)="createTplModal(tplHelpTitle, tplHelpContent, tplHelpFooter)">
                                help_outline
                            </mat-icon>
                            <ng-template #tplHelpTitle>
                                <span>{{'service_type.help_configure.modal_title' | translate}}</span>
                            </ng-template>
                            <ng-template #tplHelpContent>
                                <p><b>{{'service_type.help_configure.modal_content1' | translate}}</b>
                                    {{'service_type.help_configure.modal_content2' | translate}}
                                </p>
                                <p><b>{{'service_type.help_configure.modal_content3' | translate}}</b>
                                    {{'service_type.help_configure.modal_content4' | translate}}
                                </p>
                                <p><b>{{'service_type.help_configure.modal_content5' | translate}}</b>
                                    {{'service_type.help_configure.modal_content6' | translate}}
                                </p>
                                <p><b>{{'service_type.help_configure.modal_content7' | translate}}</b>
                                    {{'service_type.help_configure.modal_content8' | translate}}
                                </p>
                                <p><b>{{'service_type.help_configure.modal_content9' | translate}}</b>
                                    {{'service_type.help_configure.modal_content10' | translate}}
                                </p>

                                <p><b>{{'service_type.help_configure.modal_content15' | translate}}</b>
                                    {{'service_type.help_configure.modal_content16' | translate}}
                                    <span style="color: red;">{{'service_type.help_configure.modal_content_only_mobile'
                                        | translate}}</span>
                                </p>
                                <p><b>{{'service_type.help_configure.modal_content17' | translate}}</b>
                                    {{'service_type.help_configure.modal_content18' | translate}}
                                    <span style="color: red;">{{'service_type.help_configure.modal_content_only_mobile'
                                        | translate}}</span>
                                </p>

                                <p><b>{{'service_type.help_configure.modal_content11' | translate}}</b>
                                    {{'service_type.help_configure.modal_content12' | translate}}
                                </p>
                                <p><b>{{'service_type.help_configure.modal_content13' | translate}}</b>
                                    {{'service_type.help_configure.modal_content14' | translate}}
                                </p>
                            </ng-template>
                            <ng-template #tplHelpFooter>
                                <button nz-button (click)="destroyTplModal()" class="v2-color-deny" type="button">
                                    {{'button.close' | translate}}
                                </button>
                            </ng-template>
                        </mat-panel-title>
                        <!--Kiểm tra-->
                        <p>{{'header.check' | translate}}</p>
                        <div class="form-group d-flex">
                            <div  class="group-checkbox">
                                <button [ngStyle]="{ 'opacity': this.documents.isVerifySubject? 0.5 : 1 }" id="check_num_document" type="button" mat-icon-button class="v2-color-deny"
                                    [disabled]="documents.id && documents.type == 2|| this.documents.isVerifySubject ? true : false"
                                    (click)="onAllowCheckSign('checkCertNumber')">
                                    <mat-icon *ngIf="documents.checkCertNumber"
                                        [ngClass]="documents.id && documents.type == 2 ? '' : 'mat-primary'">
                                        check_box
                                    </mat-icon>
                                    <mat-icon *ngIf="documents.checkCertNumber === false"
                                        [ngClass]="documents.id && documents.type == 2 ? '' : 'mat-primary'">
                                        check_box_outline_blank
                                    </mat-icon>
                                </button>
                                <label class="checkbox-label px-3" for="check_num_document">
                                    {{'search_form.service_type_checkCertNumber' | translate}}
                                </label>
                            </div>
                            <div class="group-checkbox px-5">
                                <button id="check_name" type="button"
                                    [disabled]="documents.id && documents.type == 2 ? true : false" mat-icon-button
                                    class="v2-color-deny" (click)="onAllowCheckSign('checkName')">
                                    <mat-icon *ngIf="documents.checkName"
                                        [ngClass]="documents.id && documents.type == 2 ? '' : 'mat-primary'">
                                        check_box
                                    </mat-icon>
                                    <mat-icon *ngIf="documents.checkName === false"
                                        [ngClass]="documents.id && documents.type == 2 ? '' : 'mat-primary'">
                                        check_box_outline_blank
                                    </mat-icon>
                                </button>
                                <label class="checkbox-label px-3" for="check_name">
                                    {{'search_form.service_type_checkName' | translate}}
                                </label>
                            </div>
                            <div class="group-checkbox">
                                <button [ngStyle]="{ 'opacity': this.documents.isVerifySubject? 0.5 : 1 }" id="check_otp" type="button"
                                    [disabled]="documents.id && documents.type == 2 || this.documents.isVerifySubject ? true : false" mat-icon-button
                                    class="v2-color-deny" (click)="onAllowCheckSign('checkOtp')">
                                    <mat-icon *ngIf="documents.checkOtp"
                                        [ngClass]="documents.id && documents.type == 2 ? '' : 'mat-primary'">check_box
                                    </mat-icon>
                                    <mat-icon *ngIf="documents.checkOtp === false"
                                        [ngClass]="documents.id && documents.type == 2 ? '' : 'mat-primary'">
                                        check_box_outline_blank
                                    </mat-icon>
                                </button>
                                <label class="checkbox-label px-3" for="check_otp">
                                    {{'search_form.service_type_checkOtp' | translate}}
                                </label>
                            </div>
                        </div>
                      <p *ngIf="isNotAttestedUser">{{'kyc.confirm_account' | translate}}</p>
                      <div class="form-group d-flex" *ngIf="isNotAttestedUser">
                        <div class="group-checkbox">
                          <button id="check_xmct" type="button"
                                  mat-icon-button class="v2-color-deny"
                                  (click)="onClickVerifySubject()">
                            <mat-icon *ngIf="documents.isVerifySubject"  [ngClass]="documents.id && documents.type == 2 ? '' : 'mat-primary'">check_box</mat-icon>
                            <mat-icon *ngIf="documents.isVerifySubject === false"  [ngClass]="documents.id && documents.type == 2 ? '' : 'mat-primary'">
                              check_box_outline_blank
                            </mat-icon>
                          </button>
                          <label class="checkbox-label px-3" for="check_xmct">
                            <i> {{'search_form.service_type_xmct1' | translate}} </i> <b>{{'search_form.service_type_xmct2' | translate}}</b> <i>{{'search_form.service_type_xmct3' | translate}}</i>
                          </label>
                        </div>
                      </div>
                        <!--Phương thức ký-->
                        <p>{{'header.signing_method' | translate}}</p>
                        <div class="mb-3 mt-3">
                            <div class="form-group">
                                <table class="mat-table" border="1" style="text-align: center; height: 7rem;">
                                    <tr class="mat-header-row">
                                        <th class="mat-header-cell">{{'header.signing_method' | translate}}</th>
                                        <th class="mat-header-cell" style="width: 70px;"></th>
                                        <th class="mat-header-cell">{{'search_form.service_type_supportEKYC' |
                                            translate}}</th>
                                    </tr>
                                    <tr class="mat-row justify-content-center">
                                        <td class="mat-cell">{{'search_form.service_type_allowOtp' | translate}}</td>
                                        <td class="mat-cell">
                                            <button id="sign-otp" style="margin: 0 15px;"
                                                [disabled]="documents.id && documents.type == 2 ? true : false"
                                                mat-icon-button class="v2-color-deny" type="button"
                                                (click)="onAllowCheckSign('allowOtp')">
                                                <mat-icon *ngIf="documents.allowOtp"
                                                    [ngClass]="documents.id && documents.type == 2 ? '' : 'mat-primary'">
                                                    check_box
                                                </mat-icon>
                                                <mat-icon *ngIf="documents.allowOtp === false"
                                                    [ngClass]="documents.id && documents.type == 2 ? '' : 'mat-primary'">
                                                    check_box_outline_blank
                                                </mat-icon>
                                            </button>
                                        </td>
                                        <td class="mat-cell">
                                            <div class="d-flex justify-content-center" style="text-align: center">
                                                <div class="group-checkbox">
                                                    <button id="sign-ekyc" type="button" mat-icon-button
                                                        class="v2-color-deny"
                                                        [disabled]="isDisableEkyc || (!documents.allowOtp && !documents.allowImage) || (documents.id && documents.type == 2)"
                                                        (click)="onAllowCheckSign('supportEkyc')">
                                                        <mat-icon
                                                            *ngIf="documents.ekycSupportConfig === 1 && !isDisableEkyc"
                                                            [ngClass]="isDisableEkyc || (!documents.allowOtp && !documents.allowImage) || (documents.id && documents.type == 2) ? '' : 'mat-primary'">
                                                            radio_button_checked
                                                        </mat-icon>
                                                        <mat-icon
                                                            *ngIf="documents.ekycSupportConfig !== 1 && !isDisableEkyc"
                                                            [ngClass]="isDisableEkyc || (!documents.allowOtp && !documents.allowImage) || (documents.id && documents.type == 2) ? '' : 'mat-primary'">
                                                            radio_button_unchecked
                                                        </mat-icon>
                                                        <mat-icon *ngIf="isDisableEkyc" class="color-gray">
                                                            radio_button_unchecked
                                                        </mat-icon>
                                                    </button>
                                                    <label class="checkbox-label" style="font-weight: 500;"
                                                        for="sign-ekyc" [class.color-gray]="isDisableEkyc">
                                                        {{'search_form.service_type_EKYC' | translate}}
                                                    </label>
                                                </div>

                                                <div class="group-checkbox">
                                                    <button id="sign-advanced-ekyc" type="button" mat-icon-button
                                                        class="v2-color-deny"
                                                        [disabled]="isDisableEkycAdvanced || (!documents.allowOtp && !documents.allowImage) || (documents.id && documents.type == 2)"
                                                        (click)="onAllowCheckSign('supportEkycAdvanced')">
                                                        <mat-icon
                                                            *ngIf="documents.ekycSupportConfig === 2 && !isDisableEkycAdvanced"
                                                            [ngClass]="isDisableEkycAdvanced || (!documents.allowOtp && !documents.allowImage) || (documents.id && documents.type == 2) ? '' : 'mat-primary'">
                                                            radio_button_checked
                                                        </mat-icon>
                                                        <mat-icon
                                                            *ngIf="documents.ekycSupportConfig !== 2 && !isDisableEkycAdvanced"
                                                            [ngClass]="isDisableEkycAdvanced || (!documents.allowOtp && !documents.allowImage) || (documents.id && documents.type == 2) ? '' : 'mat-primary'">
                                                            radio_button_unchecked
                                                        </mat-icon>
                                                        <mat-icon *ngIf="isDisableEkycAdvanced" class="color-gray">
                                                            radio_button_unchecked
                                                        </mat-icon>
                                                    </button>
                                                    <label class="checkbox-label" style="font-weight: 500;"
                                                        for="sign-advanced-ekyc"
                                                        [class.color-gray]="isDisableEkycAdvanced">
                                                        {{'search_form.service_type_EkycAdvanced' | translate}}
                                                    </label>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <!-- <tr class="mat-row">
                                        <td class="mat-cell">{{'search_form.service_type_allowImage' | translate}}</td>
                                        <td class="mat-cell">
                                            <button id="sign-image"
                                                    style="margin: 0 15px;" type="button"
                                                    mat-icon-button class="v2-color-deny"
                                                    (click)="onAllowCheckSign('allowImage')">
                                                <mat-icon *ngIf="documents.allowImage" class="mat-primary">check_box
                                                </mat-icon>
                                                <mat-icon *ngIf="documents.allowImage === false" class="mat-primary">
                                                    check_box_outline_blank
                                                </mat-icon>
                                            </button>
                                        </td>
                                    </tr> -->
                                </table>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
                <!-- Lưu ý -->
                <ng-container *ngIf="documents.id && documents.type == 2">
                    <div class="w-100 note-class">
                        <div class="d-flex align-items-center">
                            <i class="fa fa-exclamation-circle" style="color: red; font-size: 20px;"
                                aria-hidden="true"></i>
                            <div style="color: red;" class="font-weight-bold ml-3">{{'title.note' | translate}}</div>
                        </div>
                        <div style="padding-left: 33px;">{{'service_type.message_service_type' | translate}}</div>
                    </div>
                </ng-container>
                <!--Cấu hình thông báo-->
                <mat-accordion>
                    <mat-expansion-panel expanded="true" class="mt-3">
                        <mat-panel-title class="mat-panel-title mt-3 d-flex justify-content-between align-items-center">
                            {{'search_form.notification_config' | translate}}
                        </mat-panel-title>
                        <div class="col-12">
                            <mat-tab-group mat-align-tabs="center" mat-stretch-tabs>
                                <!-- Tiến trình xử lý-->
                                <mat-tab
                                    [label]="'service_type.remind_configuration.configure_notify_sms_contract' | translate">
                                    <div class="reminder-to-sign"> {{'service_type.remind_configuration.set_send_sms' |
                                        translate}}
                                        <mat-button-toggle-group class="toggle-button">
                                            <mat-button-toggle [checked]="documents.isOnSMSInFlow"
                                                [value]="documents.isOnSMSInFlow"
                                                (click)="clickChangeSMSConfiguration(true)">
                                                {{'service_type.remind_configuration.on_status' | translate}}
                                            </mat-button-toggle>
                                            <mat-button-toggle [checked]="!documents.isOnSMSInFlow"
                                                [value]="!documents.isOnSMSInFlow"
                                                (click)="clickChangeSMSConfiguration(false)">
                                                {{'service_type.remind_configuration.off_status' | translate}}
                                            </mat-button-toggle>
                                        </mat-button-toggle-group>
                                    </div>
<!--                                  Theem chon SMS or Email-->
                                  <div class="reminder-to-sign" *ngIf=documents.isOnSMSInFlow>
                                    {{'service_type.remind_configuration.means_of_sending_notification' | translate}}
                                    <div>
                                      <mat-checkbox class="pl-5" color="primary" [checked]="checkSMSInFlow(documents)"
                                                    (change)="checkboxSendSMSCustomerInflow()">
                                        SMS
                                      </mat-checkbox>
                                    </div>
                                    <div>

                                      <mat-checkbox class="px-5" color="primary"
                                                    [checked]="checkEmailInFlow(documents?.notificationServiceTypes)"
                                                    (change)="checkSendEmailCustomerInflow()">
                                        Email
                                      </mat-checkbox>
                                    </div>
                                  </div>
                                  <div>
                                    <mat-error
                                      *ngIf="isCheckEmailInFlow == false && isCheckSMSInFlow === false && documents.isOnSMSInFlow">
                                      {{'validation.selectObjectValidate' | translate}}
                                    </mat-error>
                                  </div>


                                    <!--Đối tượng nhắc ký-->
                                    <div style="margin-top: 10px" *ngIf=documents.isOnSMSInFlow>
                                        {{'service_type.remind_configuration.send_sms_object' | translate}}
                                        <span>*</span>
                                        <div class="sign-prompt-object">
                                          <div style="padding-right: 15px;">
                                            <div style="margin-top: 10px;">
                                              <mat-checkbox class="px-1" color="primary" style="font-weight: bold;"
                                                            [disabled]="!isCheckSMSInFlow"
                                                            [checked]="documents.sendSMSInternalInFlow && documents.sendSMSInternalInFlow.includes('1')"
                                                            (change)="checkSendSMSInternalInFlow()">
                                                {{'search_form.internal' | translate}}
                                              </mat-checkbox>
                                            </div>
                                            <div style="margin-top: 10px;">
                                              <mat-checkbox class="px-1" color="primary" style="font-weight: bold;"
                                                            [checked]="documents.sendSMSCustomerInFlow && documents.sendSMSCustomerInFlow.includes('1')"
                                                            [disabled]="!isCheckSMSInFlow"
                                                            (change)="checkSendSMSCustomerInFlow()">
                                                {{'search_form.customer' | translate}}
                                              </mat-checkbox>
                                            </div>
                                          </div>
                                          <div>
                                            <div>
                                              <button mat-stroked-button color="primary" type="button" style="margin-bottom: 10px; font-weight: bold;"
                                              [disabled]="!isCheckSMSInFlow || (documents.sendSMSInternalInFlow && documents.sendSMSInternalInFlow.includes('0'))"
                                              (click)="chonSuKienGuiSMS('internal', 'PROCESS')">
                                              {{'service_type.remind_configuration.select_event_sms' | translate}}
                                            </button>
                                            </div>
                                            <div>
                                            <button mat-stroked-button color="primary" type="button" style="font-weight: bold;"
                                                   [disabled]="!isCheckSMSInFlow || (documents.sendSMSCustomerInFlow && documents.sendSMSCustomerInFlow.includes('0'))"
                                                    (click)="chonSuKienGuiSMS('customer', 'PROCESS')">
                                                {{'service_type.remind_configuration.select_event_sms' | translate}}
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                      
                      
                                        <div style="min-height: 30px !important; padding-top: 50px">
                                          <mat-error
                                            *ngIf="checkIsErrorProcess()">
                                            {{'validation.selectObjectToSendSMS' | translate}}
                                          </mat-error>
                                        </div>
                                      </div>
<!--                                  add Send Email-->
                                  <div style="margin-top: 10px" *ngIf="documents.isOnSMSInFlow">
                                    {{'service_type.remind_configuration.send_mail_object' | translate}}
                                    <span>*</span>
                                    <div class="sign-prompt-object">
                                      <div style="padding-left:48px" >
                                        <mat-checkbox color="primary" [checked]="getEmailConfig(documents.notificationServiceTypes)"
                                                      [disabled]="!isCheckEmailInFlow"
                                                      (change)="checkSendMailCustomerInFlow()">
                                          {{'search_form.customer' | translate}}
                                        </mat-checkbox>
                                      </div>
                                      <div>
                                        <mat-checkbox class="px-5" color="primary"
                                                      [checked]="checkboxSendEmailInternalInFlow(documents.notificationServiceTypes)"
                                                      [disabled]="!isCheckEmailInFlow"
                                                      (change)="checkSendEmailInternalInFlow()">
                                          {{'search_form.internal' | translate}}
                                        </mat-checkbox>
                                      </div>
                                      <div>
                                        <mat-form-field>
                                          <mat-label>{{'service_type.remind_configuration.internal_object' |
                                            translate}}</mat-label>
                                          <mat-select #select multiple
                                                      [value]="cbxSendEmailInternalInFlow()"
                                                      [disabled]="!isCheckEmailInFlow"
                                                      (valueChange)="documents.notificationServiceTypes[getIndex()].sendEmailInternal = $event">
                                            <mat-option
                                              *ngFor="let internalObject of internalObjectsToSendSMS"
                                              [value]="internalObject.value"
                                              (click)="formChangingCheckSendEmailInternalInFlowEvent()">
                                              {{internalObject.viewValue | translate}}
                                            </mat-option>
                                          </mat-select>
                                        </mat-form-field>
                                      </div>
                                    </div>
                                    <div style="min-height: 30px !important; padding-top: 15px">
                                      <mat-error
                                        *ngIf="isCheckEmailInFlow == true && !checkValidateEmail(documents.notificationServiceTypes)">
                                        {{'validation.selectObjectToSendEmail' | translate}}
                                      </mat-error>
                                    </div>
                                  </div>
<!--                                  Done add-->
                                    <div>
                                        <span style="font-style: italic;">
                                            <span style="color: red;"> {{'service_type.remind_configuration.note' |
                                                translate}}
                                            </span>
                                            {{'service_type.remind_configuration.note_send_sms_in_flow_1' | translate}}
                                            <strong>{{'service_type.remind_configuration.on_status' |
                                                translate}}</strong>
                                            {{'service_type.remind_configuration.note_send_sms_in_flow_2' | translate}}
                                            {{'service_type.remind_configuration.note_send_sms_in_flow_3' | translate}}
                                            {{'service_type.remind_configuration.note_send_sms_in_flow_4' | translate}}
                                            <strong>{{'service_type.remind_configuration.off_status' |
                                                translate}}</strong>{{'service_type.remind_configuration.note_send_sms_in_flow_5' | translate}}
                                        </span>
                                    </div>
                                </mat-tab>

                                <!-- Nhắc xử lý tự động-->
                                <mat-tab [label]="'search_form.reminder_to_sign' | translate">
                                    <div class="reminder-to-sign"> {{'search_form.reminder_to_sign_contract' |
                                        translate}}
                                        <mat-button-toggle-group class="toggle-button">
                                            <mat-button-toggle [checked]="documents.isOnPromptToSign" id="on-button"
                                                [value]="documents.isOnPromptToSign" (click)="clickSend(true)">
                                                {{'search_form.btn_config_notify_on' | translate}}
                                            </mat-button-toggle>
                                            <mat-button-toggle [checked]="!documents.isOnPromptToSign"
                                                [value]="!documents.isOnPromptToSign" (click)="clickSend(false)">
                                                {{'search_form.btn_config_notify_off' | translate}}
                                            </mat-button-toggle>
                                        </mat-button-toggle-group>
                                    </div>

                                    <!--Loại cấu hình-->
                                    <div class="reminder-to-sign" *ngIf="documents.isOnPromptToSign">
                                        {{'search_form.config_type' | translate}}
                                        <mat-checkbox class="mat-checkbox px-5" color="primary"
                                            [disabled]="!documents.isOnPromptToSign"
                                            (change)="documents.isSendSmsSign = !documents.isSendSmsSign; checkoff()"
                                            (click)="remindSmsChange()" [checked]="documents.isSendSmsSign">
                                            SMS
                                        </mat-checkbox>
                                        <mat-checkbox class="mat-checkbox" color="primary" checked="true" disabled>
                                            Email
                                        </mat-checkbox>
                                    </div>

                                    <div style="display: flex; align-items: flex-start; gap: 40px; margin-top: 10px" *ngIf="documents.isOnSMSInFlow || documents.isOnPromptToSign">

                                        <!-- Cột trái: Đối tượng gửi SMS -->
                                        <div style="min-width: 300px" *ngIf="documents.isOnPromptToSign">
                                          {{'search_form.sign_prompt_object' | translate}}
                                          <span>*</span>
                                          <div class="sign-prompt-object">
                                            <div style="padding-right: 15px;">
                                              <div style="margin-top: 10px;">
                                                <mat-checkbox class="px-1" color="primary" style="font-weight: bold;"
                                                  [checked]="documents.isSendCustomerSign"
                                                  [disabled]="documents.isSendSmsSign === false"
                                                  (change)="checkCustomerSms()">
                                                  {{'search_form.customer' | translate}}
                                                </mat-checkbox>
                                              </div>
                                              <div style="margin-top: 10px;">
                                                <mat-checkbox class="px-1" color="primary" style="font-weight: bold;"
                                                  [disabled]="documents.isSendSmsSign === false"
                                                  [checked]="documents.sendInternalSign && documents.sendInternalSign.includes('1')"
                                                  (change)="checkInternalSms()">
                                                  {{'search_form.internal' | translate}}
                                                </mat-checkbox>
                                              </div>                    
                                            </div>
                                            <div>
                                              <div style="padding-top: 15px;">
                                                <button mat-stroked-button color="primary" type="button" style="font-weight: bold;"
                                                  [disabled]="!documents.isSendCustomerSign || (documents.isSendSmsSign === false)"
                                                  (click)="chonSuKienGuiSMS('customer', 'REMINDER')">
                                                  {{'service_type.remind_configuration.select_event_sms' | translate}}
                                                </button>
                                              </div>
                                              <div style="padding-top: 8px;">
                                                <button mat-stroked-button color="primary" type="button" style="margin-bottom: 10px; font-weight: bold;"
                                                  [disabled]="!(documents.sendInternalSign && documents.sendInternalSign.includes('1')) || (documents.isSendSmsSign === false)"
                                                  (click)="chonSuKienGuiSMS('internal', 'REMINDER')">
                                                  {{'service_type.remind_configuration.select_event_sms' | translate}}
                                                </button>
                                              </div>                       
                                            </div>
                                          </div>
                      
                                          <div style="min-height: 30px !important; padding-top: 50px">
                                            <mat-error
                                              *ngIf="checkIsErrorRemind()">
                                              {{'validation.signPromptObject' | translate}}
                                            </mat-error>
                                          </div>
                                          <div style="min-height: 30px !important;">
                                            <mat-error
                                              *ngIf="checkIsErrorRemindEmail()">
                                              {{'validation.signPromptObjectEmail' | translate}}
                                            </mat-error>
                                          </div>
                                        </div>
                      
                                        
                      
                                        <!-- Cột phải: Email & api -->
                                          <div style="min-width: 300px;" *ngIf="documents.isOnPromptToSign">
                                            {{'search_form.sign_prompt_object_email_api' | translate}}
                                            <span>*</span>
                                          
                                           <div style="gap: 60px; display: flex;">
                      
                                              <!-- Nhóm checkbox -->
                                              <div style="padding-top: 20px; gap: 60px; display: flex;">
                                                <div>
                                                  <mat-checkbox color="primary"
                                                               [checked]="documents.isSendPromptEmailCustomerSign"
                                                               (change)="checkCustomer()">
                                                    {{'search_form.customer' | translate}}
                                                  </mat-checkbox>
                                                </div>
                                                <div>
                                                  <mat-checkbox color="primary"
                                                                [checked]="documents.sendPromptEmailInternalSign && documents.sendPromptEmailInternalSign.length > 0"
                                                                (change)="checkInternal()">
                                                    {{'search_form.internal' | translate}}
                                                  </mat-checkbox>
                                                </div>
                                              </div>
                                            
                                             <!-- Select đối tượng nội bộ -->
                                             <div>
                                               <mat-form-field>
                                                 <mat-label>{{'search_form.internal_object' | translate}}</mat-label>
                                                 <mat-select #select multiple
                                                             [value]="documents.sendPromptEmailInternalSign"
                                                              (valueChange)="changeValueSign($event)">
                                                    <mat-option *ngFor="let internalObject of internalObjects"
                                                                [value]="internalObject.value"
                                                                (click)="formChangingCheckInternalRemindEvent()">
                                                      {{internalObject.viewValue | translate}}
                                                    </mat-option>
                                                  </mat-select>
                                                </mat-form-field>
                                              </div>
                                            
                                            </div> <!-- đóng div flex (gap: 60px) -->
                                            <div style="min-height: 30px !important; padding-top: 50px">
                                                <mat-error
                                                  *ngIf="checkIsErrorEmail()">
                                                  {{'validation.signPromptObjectEmail' | translate}}
                                                </mat-error>
                                              </div>
                                          </div> <!-- đóng div min-width: 300px -->
                      
                                      </div>

                                    <!--Chu kỳ nhắc ký-->
                                    <div class="reminder-to-sign" *ngIf="documents.isOnPromptToSign">
                                        <mat-form-field class="w-100">
                                            <input type="number" min="1" maxlength="9"
                                                oninput="validity.valid||(value=''); if (Number(this.value) > 30) this.value = '30'"
                                                class="input-cycle" required matInput
                                                [placeholder]="'search_form.cycle_send_sign' | translate"
                                                name="cycleSendSign" [(ngModel)]="documents.cycleSendSign"
                                                #cycleSendSign="ngModel" (ngModelChange)="onChangeFormInput()">
                                            {{'search_form.day_time' | translate}}
                                            <mat-error *ngIf="cycleSendSign.invalid">
                                                {{'validation.cycle_sign_validate' | translate}}
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="reminder-to-sign"><span style="font-style: italic;"><span
                                                style="color: red;">
                                                {{'search_form.note_remind_sign_contract_pre' | translate}} </span>
                                            {{'search_form.note_remind_sign_contract' | translate}}</span>
                                    </div>
                                </mat-tab>

                                <!-- Nhắc hết hạn-->
                                <mat-tab [label]="'search_form.expiration_reminder' | translate">
                                    <div class="reminder-to-sign"> {{'search_form.expiration_reminder_contract' |
                                        translate}}
                                        <mat-button-toggle-group class="toggle-button">
                                            <mat-button-toggle [checked]="documents.isOnNotifyExpireContract" value="on"
                                                (click)="clickSendExpire(true)">{{'search_form.btn_config_notify_on' |
                                                translate}}
                                            </mat-button-toggle>
                                            <mat-button-toggle [checked]="!documents.isOnNotifyExpireContract"
                                                value="off" (click)="clickSendExpire(false)">
                                                {{'search_form.btn_config_notify_off' | translate}}
                                            </mat-button-toggle>
                                        </mat-button-toggle-group>
                                    </div>

                                    <!--Loại cấu hình-->
                                    <div class="reminder-to-sign" *ngIf="documents.isOnNotifyExpireContract">
                                    <div class="notify-method-wrapper">
                                        <span class="notify-method-label">{{'search_form.config_type' | translate}}</span>
                                        <div class="notify-method-col">
                                            <div class="notify-method-row" style="margin-top: 3px;">
                                                <mat-checkbox class="mat-checkbox px-5" color="primary" style="padding-top: 4px;"
                                                (change)="checkSmsExpire()"
                                                [checked]="documents.isSendSmsExpireContract"
                                                (click)="isFormChanging = true">SMS</mat-checkbox>
                                                
                                                <button mat-stroked-button color="primary" type="button" style="font-weight: bold;"
                                                [disabled]="!documents.isSendSmsExpireContract"
                                                (click)="chonSuKienGuiSMS('internal', 'EXPIRY_REMINDER')">
                                                {{'service_type.remind_configuration.select_event_sms' | translate}}
                                            </button>
                                        </div>
                                        
                                        <mat-checkbox class="mat-checkbox" color="primary" style="margin-left: 48px;"
                                        checked="true" disabled>Email</mat-checkbox>
                                            </div>
                                        </div>
                                    </div>

                                    <!--Thời gian nhắc-->
                                    <div class="reminder-to-sign" *ngIf="documents.isOnNotifyExpireContract">
                                        <mat-form-field class="w-100">
                                            <input type="number" min="1" maxlength="9"
                                                oninput="validity.valid||(value=''); if (Number(this.value) > 100) this.value = '100'"
                                                class="input-cycle" matInput
                                                [placeholder]="'search_form.time_notify_before_expire' | translate"
                                                name="reminderTime" required (ngModelChange)="onChangeFormInput()"
                                                [(ngModel)]="documents.timeNotifyBeforeExpire" #timeNotify="ngModel">
                                            {{'search_form.day_before_expire' | translate}}
                                            <mat-error *ngIf="timeNotify.invalid">
                                                {{'validation.time_notify' | translate}}
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <!-- Chu kỳ nhắc hết hạn-->
                                    <div class="reminder-to-sign" *ngIf="documents.isOnNotifyExpireContract">
                                        <mat-form-field class="w-100">
                                            <input type="number" min="0" maxlength="9"
                                                oninput="validity.valid||(value=''); if (Number(this.value) > 30) this.value = '30'"
                                                class="input-cycle" matInput name="cycleNotify"
                                                [placeholder]="'search_form.cycle_reminder' | translate"
                                                [(ngModel)]="documents.cycleNotifyExpireContract">
                                            {{'search_form.day_time' | translate}}
                                        </mat-form-field>
                                    </div>
                                </mat-tab>
                            </mat-tab-group>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>

            </mat-card-content>
        </mat-card-content>
         <!--Button action-->
         <div class="col-12 mb-3" style="padding-top: 20px; text-align: center">
            <mat-dialog-actions class="mt-2 mat-dialog-actions-custom">
                <button mat-stroked-button color="primary" class="mr-3 mb-1 button" type="button"
                    (click)="onNoClick()">
                    <mat-icon class="mr-0">cancel</mat-icon>
                    {{'button.cancel' | translate}}
                </button>
                <ng-container>
                    <button mat-raised-button type="submit" color="primary" class="button"
                        [disabled]="(f.form.invalid || !isFormChanging || (documents.isOnAutoNumber && !listDataPreview)) ||(f.form.invalid && documents.configGeneral === 1) ||
                              ((f.form.invalid || !isFormChanging || (!isCheck && documents.isOnPromptToSign)

                               || !checkDisableInFlow()
                               || checkIsErrorRemind()
                                || checkIsErrorProcess()
                                || checkIsErrorEmail()
                               || (documents.timeNotifyBeforeExpire == null && documents.isOnNotifyExpireContract)) && documents.configGeneral === 2)">
                        <mat-icon class="mr-0">save</mat-icon>
                        <ng-container *ngIf="!documents.id; else saveButton">
                            {{'button.add_service_type' | translate}}
                        </ng-container>
                        <ng-template #saveButton> {{'button.save' | translate}}</ng-template>
                    </button>
                </ng-container>
            </mat-dialog-actions>
        </div>
    </mat-card>
</form>
